// extracted by mini-css-extract-plugin
export default {"search_input":"AnimalsList_search_input__W+dah","filtersContainer":"AnimalsList_filtersContainer__hWBCJ","spin":"AnimalsList_spin__5pSZT"};